export let LOAD_MORE_BUTTON_TYPE_VALUES = /*#__PURE__*/function (LOAD_MORE_BUTTON_TYPE_VALUES) {
  LOAD_MORE_BUTTON_TYPE_VALUES[LOAD_MORE_BUTTON_TYPE_VALUES["TEXT"] = 1] = "TEXT";
  LOAD_MORE_BUTTON_TYPE_VALUES[LOAD_MORE_BUTTON_TYPE_VALUES["SHAPE"] = 2] = "SHAPE";
  return LOAD_MORE_BUTTON_TYPE_VALUES;
}({});
//# sourceMappingURL=load-more-button-type-values.js.map